import {
  collection,
  doc,
  getDocs,
  getDoc,
  updateDoc,
  query,
  where,
  orderBy,
} from 'firebase/firestore'
import { db } from './firebase'
import { UserRole } from '../context/AuthContext'
export interface User {
  id: string
  email: string
  displayName: string
  photoURL?: string
  role: UserRole
  createdAt: Date
}
// Get all users
export const getAllUsers = async () => {
  const usersRef = collection(db, 'users')
  const q = query(usersRef, orderBy('createdAt', 'desc'))
  const snapshot = await getDocs(q)
  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  })) as User[]
}
// Get users by role
export const getUsersByRole = async (role: UserRole) => {
  const usersRef = collection(db, 'users')
  const q = query(
    usersRef,
    where('role', '==', role),
    orderBy('createdAt', 'desc'),
  )
  const snapshot = await getDocs(q)
  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  })) as User[]
}
// Get user by ID
export const getUserById = async (id: string) => {
  const docRef = doc(db, 'users', id)
  const docSnap = await getDoc(docRef)
  if (docSnap.exists()) {
    return { id: docSnap.id, ...docSnap.data() } as User
  }
  return null
}
// Update user role
export const updateUserRole = async (userId: string, role: UserRole) => {
  const userRef = doc(db, 'users', userId)
  await updateDoc(userRef, { role })
  return userId
}
// Get pending users (users who have signed in but don't have an approved role yet)
export const getPendingUsers = async () => {
  return getUsersByRole('pending')
}
